// @flow
import config from "@config";
import type { State } from "@store/reducers";
import {
  PASSWORD_SET_PATH,
  REGISTRATION_PATH,
  NOT_FOUND_PATH,
  SERVICE_UNAVAILABLE_PATH,
} from "@routes/constants";
import type { PaginationExtendedType } from "@types";

export const getCurrentPath = (state: State): string => window.location.pathname;

export const getRedirect = (state: State): ?string => "/";

// $FlowIgnoreMe match doesn't exist in connected-react-router, needs investigating
export const getRouteParams = (state: State): Object | null => (state.match || {}).params;

export const getRouteIdParam = (state: State): number => parseInt(getRouteParams(state).id);

export const getRouteClientIdFromState = (state: State) =>
  (((state || {}).context || {}).client || {}).id;

export const getClientIdParam = (state: State) => {
  const matches = window.location.pathname.match(
    /(client|data|hierarchy|service|administration|reporting)\/([0-9]+)\//,
  );
  return matches ? matches[2] : null;
};

export const getRouteClientIdParam = (state: State): number =>
  parseInt((getRouteParams(state) || {}).clientId);

export const getRouteParam = (param: string) => (state: State): Object | null =>
  getRouteParams(state)[param];

export const getPagination = (list: any): PaginationExtendedType => {
  return {
    ...(list || {}).pagination,
    totalPages:
      Math.ceil((list || {}).totalElements / ((list || {}).pagination || {}).pageSize) || 0,
  };
};

// $FlowIgnore offset doesn't exist in connected-react-router, needs investigating further
export const getPageRangeOffset = (state: State): number => state.offset + 1;

export const getPageRange = (state: State): number =>
  getPageRangeOffset(state) + config.resultsPerPage - 1;

export const transformOptions = (data: Object) =>
  data && data.length ? data.map(item => ({ label: item.title, value: item.const })) : data;

// Redux form selector
export const getReduxForm = (state: State) => {
  return state.form;
}; // Redux form selector
export const getReduxFormValues = (state: State, retuxFormName: string) => {
  return (state.form[retuxFormName] || {}).values || {};
};

export const isStaticPage = () => {
  const pages = [
    PASSWORD_SET_PATH,
    REGISTRATION_PATH,
    NOT_FOUND_PATH,
    SERVICE_UNAVAILABLE_PATH,
  ].filter(f => f === window.location.pathname);

  return pages.length > 0;
};

export const isOperatingCompany = () => {
  // do not pass the flag "is_operating_company"
  // the (transformFilters) method will remove it from the request query params
  if (config.env === "test" || config.env === "dev" || config.env === "uat") {
    return null;
  }

  // by default, we pass is_operating_company=false
  // where the API will NOT return operating companies like GS
  return false;
};
